import { useTranslation } from 'react-i18next';

import { Select, SelectProps } from '@mantine/core';

import { useGetCompanyRoleQuery } from '@api/companyRole.api';

interface CompanyRoleSelectorProps extends SelectProps {
  marketCategoryName: string;
}

export default function CompanyRoleSelector({
  marketCategoryName,
  ...props
}: CompanyRoleSelectorProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetCompanyRoleQuery(marketCategoryName, {
    skip: marketCategoryName === undefined,
  });

  return (
    <Select
      label={t('selectors.companyRole.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.companyRole.placeholder')
      }
      data={data.map((companyRole) => ({
        label: companyRole.name,
        value: companyRole.id.toString(),
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
